import React, { useEffect } from 'react';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';

const TermsConditionsPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <style>{`
                .terms-section {
                    opacity: 0;
                    animation: fadeIn 0.5s ease forwards;
                }
                
                @keyframes fadeIn {
                    to {
                        opacity: 1;
                    }
                }
                
                .section-title {
                    position: relative;
                    display: inline-block;
                }
                
                .section-title::after {
                    content: '';
                    position: absolute;
                    bottom: -5px;
                    left: 0;
                    width: 0;
                    height: 2px;
                    background: linear-gradient(to right, #16a34a, #22c55e);
                    animation: expandLine 0.8s ease forwards;
                    animation-delay: 0.3s;
                }
                
                @keyframes expandLine {
                    to {
                        width: 100%;
                    }
                }
            `}</style>
            
            <div style={styles.pageContainer}>
                <Header />
                
                <div style={styles.heroSection}>
                    <div style={styles.heroContent}>
                        <h1 style={styles.heroTitle}>Terms & Conditions</h1>
                        <p style={styles.heroSubtitle}>
                            Please read these terms and conditions carefully before using our services
                        </p>
                    </div>
                </div>

                <div style={styles.container}>
                    <div style={styles.content}>
                        <section style={styles.section} className="terms-section">
                            <p style={styles.lastUpdated}>Last Updated: January 2025</p>
                            
                            <h2 style={styles.sectionTitle} className="section-title">
                                1. Acceptance of Terms
                            </h2>
                            <p style={styles.paragraph}>
                                By accessing or using the website of WinNest Financial Services Private Limited ("WinNest", "we", "us", or "our"), 
                                you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, 
                                please do not use our website or services.
                            </p>

                            <h2 style={styles.sectionTitle} className="section-title">
                                2. Services Description
                            </h2>
                            <p style={styles.paragraph}>
                                WinNest is an AMFI Registered Mutual Fund Distributor (ARN-81431) providing mutual fund distribution services 
                                and financial planning assistance. We do not provide investment advisory services as defined under 
                                SEBI (Investment Advisers) Regulations, 2013. Our services include:
                            </p>
                            <ul style={styles.bulletList}>
                                <li>Mutual fund scheme selection assistance</li>
                                <li>Financial planning guidance</li>
                                <li>Portfolio review services</li>
                                <li>Transaction processing support</li>
                                <li>Insurance planning assistance</li>
                            </ul>

                            <h2 style={styles.sectionTitle} className="section-title">
                                3. User Obligations
                            </h2>
                            <p style={styles.paragraph}>
                                As a user of our services, you agree to:
                            </p>
                            <ul style={styles.bulletList}>
                                <li>Provide accurate, current, and complete information</li>
                                <li>Maintain the confidentiality of your account credentials</li>
                                <li>Notify us immediately of any unauthorized use of your account</li>
                                <li>Comply with all applicable laws and regulations</li>
                                <li>Read all scheme related documents before investing</li>
                            </ul>

                            <h2 style={styles.sectionTitle} className="section-title">
                                4. Investment Risks
                            </h2>
                            <p style={styles.paragraph}>
                                Mutual fund investments are subject to market risks. Past performance is not indicative of future results. 
                                We do not guarantee any returns or promise any assured profits. You acknowledge that:
                            </p>
                            <ul style={styles.bulletList}>
                                <li>All investments carry inherent risks</li>
                                <li>The value of investments may fluctuate</li>
                                <li>You may lose part or all of your invested capital</li>
                                <li>Investment decisions are solely your responsibility</li>
                            </ul>

                            <h2 style={styles.sectionTitle} className="section-title">
                                5. Limitation of Liability
                            </h2>
                            <p style={styles.paragraph}>
                                To the maximum extent permitted by law, WinNest shall not be liable for any direct, indirect, incidental, 
                                special, consequential, or punitive damages arising from:
                            </p>
                            <ul style={styles.bulletList}>
                                <li>Your use or inability to use our services</li>
                                <li>Any investment losses or market fluctuations</li>
                                <li>Errors or omissions in information provided</li>
                                <li>Unauthorized access to your account</li>
                                <li>Any third-party actions or services</li>
                            </ul>

                            <h2 style={styles.sectionTitle} className="section-title">
                                6. Intellectual Property
                            </h2>
                            <p style={styles.paragraph}>
                                All content on this website, including but not limited to text, graphics, logos, images, and software, 
                                is the property of WinNest or its licensors and is protected by intellectual property laws. 
                                You may not reproduce, distribute, or create derivative works without our express written permission.
                            </p>

                            <h2 style={styles.sectionTitle} className="section-title">
                                7. Privacy and Data Protection
                            </h2>
                            <p style={styles.paragraph}>
                                Your use of our services is also governed by our Privacy Policy. We are committed to protecting your 
                                personal information and comply with applicable data protection laws. By using our services, 
                                you consent to the collection and use of your information as described in our Privacy Policy.
                            </p>

                            <h2 style={styles.sectionTitle} className="section-title">
                                8. Commission Disclosure
                            </h2>
                            <p style={styles.paragraph}>
                                We deal only in Regular Plans of mutual fund schemes and earn trail commission from Asset Management Companies. 
                                The commission structure varies across schemes and is disclosed at the time of investment. 
                                Direct Plans with lower expense ratios are available to investors who wish to invest directly with AMCs.
                            </p>

                            <h2 style={styles.sectionTitle} className="section-title">
                                9. Termination
                            </h2>
                            <p style={styles.paragraph}>
                                We reserve the right to terminate or suspend your access to our services at any time, without prior notice, 
                                for any reason, including breach of these Terms and Conditions. Upon termination, all provisions which by 
                                their nature should survive shall continue in effect.
                            </p>

                            <h2 style={styles.sectionTitle} className="section-title">
                                10. Governing Law and Jurisdiction
                            </h2>
                            <p style={styles.paragraph}>
                                These Terms and Conditions shall be governed by and construed in accordance with the laws of India. 
                                Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in 
                                Bengaluru, Karnataka.
                            </p>

                            <h2 style={styles.sectionTitle} className="section-title">
                                11. Modifications
                            </h2>
                            <p style={styles.paragraph}>
                                We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately 
                                upon posting on our website. Your continued use of our services after any modifications constitutes acceptance 
                                of the updated terms.
                            </p>

                            <h2 style={styles.sectionTitle} className="section-title">
                                12. Contact Information
                            </h2>
                            <p style={styles.paragraph}>
                                For any questions regarding these Terms and Conditions, please contact us at:
                            </p>
                            <div style={styles.contactBox}>
                                <p><strong>WinNest Financial Services Private Limited</strong></p>
                                <p>Email: legal@wealthnest.in</p>
                                <p>Phone: +91 90360 24568</p>
                                <p>Address: #123, 4th Cross, Jayanagar, Bengaluru - 560041</p>
                            </div>
                        </section>
                    </div>
                </div>
                
                <Footer />
            </div>
        </>
    );
};

const styles = {
    pageContainer: {
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#f9fafb',
    },
    heroSection: {
        background: 'linear-gradient(135deg, #16a34a 0%, #22c55e 100%)',
        padding: '100px 20px 60px',
        marginTop: '60px',
    },
    heroContent: {
        maxWidth: '1200px',
        margin: '0 auto',
        textAlign: 'center',
        color: 'white',
    },
    heroTitle: {
        fontSize: 'clamp(2rem, 5vw, 3rem)',
        fontWeight: '700',
        marginBottom: '1rem',
    },
    heroSubtitle: {
        fontSize: 'clamp(1rem, 2vw, 1.25rem)',
        opacity: 0.95,
    },
    container: {
        flex: 1,
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '40px 20px',
        width: '100%',
    },
    content: {
        backgroundColor: 'white',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
        padding: '40px',
    },
    section: {
        marginBottom: '20px',
    },
    lastUpdated: {
        fontSize: '0.875rem',
        color: '#6b7280',
        fontStyle: 'italic',
        marginBottom: '2rem',
    },
    sectionTitle: {
        fontSize: 'clamp(1.25rem, 3vw, 1.5rem)',
        fontWeight: '600',
        color: '#1f2937',
        marginTop: '2rem',
        marginBottom: '1rem',
    },
    paragraph: {
        fontSize: 'clamp(0.875rem, 2vw, 1rem)',
        lineHeight: '1.8',
        color: '#4b5563',
        marginBottom: '1rem',
        textAlign: 'justify',
    },
    bulletList: {
        fontSize: 'clamp(0.875rem, 2vw, 1rem)',
        lineHeight: '1.8',
        color: '#4b5563',
        marginLeft: '2rem',
        marginBottom: '1rem',
    },
    contactBox: {
        backgroundColor: '#f3f4f6',
        padding: '20px',
        borderRadius: '8px',
        marginTop: '1rem',
        fontSize: 'clamp(0.875rem, 2vw, 1rem)',
        lineHeight: '1.8',
        color: '#4b5563',
    },
};

export default TermsConditionsPage;